import EmailPage from "@/app/emails/pages/EmailPage.vue";
import EmailsManagerPage from "@/app/emailsManager/pages/EmailsManagerPage.vue";
import EmailTemplatesPage from "@/app/flows/emailTemplates/pages/EmailTemplatesPage.vue";
import TemplatesListTemplate from "@/app/flows/emailTemplates/templates/TemplatesListTemplate.vue";
import TemplateDetailsTemplate from "@/app/flows/emailTemplates/templates/TemplateDetailsTemplate.vue";

export default [
  {
    path: "/email",
    name: "email",
    // component: () => import("@/app/flows/pages/FlowsPage.vue"),
    // redirect: "/flows/forms",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "emails-manager",
        component: EmailsManagerPage,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "mailbox",
        name: "email-mailbox",
        component: EmailPage,
        // meta: {
        //   requiresAuth: true,
        // },
      },
      {
        path: "templates-email",
        component: EmailTemplatesPage,
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: "",
            component: TemplatesListTemplate,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: ":id",
            component: TemplateDetailsTemplate,
            meta: {
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
];
